import React, { useState, useEffect, useRef } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import { useNavigate } from "react-router-dom";
import leftArrow from "../../assets/images/navigate_left.svg";
import { SearchBox } from "../../components/SearchBox";
import NewReq from "../../components/farmerProductsComponents/NewRequests";
import AppliedReq from "../../components/farmerProductsComponents/AppliedRequests";
import ConfirmReq from "../../components/farmerProductsComponents/ConfirmRequests";
import RejectReq from "../../components/farmerProductsComponents/RejectRequests";
import ClosedReq from "../../components/farmerProductsComponents/ClosedRequests";
export const FarmerProducts = () => {
  const navigate = useNavigate();
  const [tabIndx, settabIndx] = useState(0);
  const [search, setSearch] = useState("");

  //   initialValues: {
  //     parentId: "",
  //     price: "",
  //     deliveryDate: "",
  //     quantity: "",
  //     unitId: "",
  //     addressId: "",
  //   },
  //   onSubmit: async (values) => {
  //     if (!selectedOption?.value) {
  //       showNotification(
  //         "Select Address",
  //         "Please select delivery address",
  //         "danger"
  //       );
  //       return;
  //     }
  //     values.addressId = selectedOption.value;

  //     const response = await bidFarmerRequest(values);
  //     if (response.status) {
  //       settabIndx(1);
  //       showNotification("Applied Bid Request", response.message, "success");

  //       setShowBidCanvas(false);
  //     } else {
  //       showNotification("Applied Bid Request", response.message, "danger");
  //       setShowBidCanvas(false);
  //     }
  //     addBidFormik.handleReset();
  //   },
  // });

  useEffect(() => {
    const handleWheel = (event) => {
      if (event.target.type === "number") {
        event.preventDefault();
      }
    };

    // Add event listener to the entire document
    document.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      // Clean up the event listener
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);
  return (
    <div className="payout_data-content">
      <div className="payout_data-head">
        <div className="payout_data-head-top">
          <div className="payout_data-left p-0">
            <div className="payout_data_ttl">Request List</div>
          </div>
          <div className="payout_data-right">
            <button
              onClick={() => {
                navigate(-1);
              }}
              className="back_btnn"
            >
              {" "}
              <img
                src={leftArrow}
                alt="Arrow"
                className="navi_left"
              /> Back{" "}
            </button>
          </div>
        </div>
      </div>
      <div className="search_container mb-4">
        <SearchBox search={search} setSearch={setSearch} />
      </div>
      <div className="tab_box">
        <Tabs selectedIndex={tabIndx} onSelect={(index) => settabIndx(index)}>
          <TabList>
            <Tab>New Requests</Tab>
            <Tab>Applied Requests</Tab>
            <Tab>Confirmed Request</Tab>
            <Tab>Rejected Request</Tab>
            <Tab>Closed Request</Tab>
          </TabList>
          <TabPanel>
            <NewReq />
          </TabPanel>
          <TabPanel>
            <AppliedReq />
          </TabPanel>
          <TabPanel>
            <ConfirmReq />
          </TabPanel>
          <TabPanel>
            <RejectReq />
          </TabPanel>
          <TabPanel>
            <ClosedReq />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};
